/*  MUI  */
import { Box } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { ClientAppsDashboard } from './internal/ClientAppsDashboard';

export const AdminApplications = () => {
    const { t } = useTranslation();

    return (
        <Box>
            <PageTitle title={t('Common.applications')} />
            <ClientAppsDashboard />
        </Box>
    );
};
